import m from "../../geodata/es2015/japanLow";
window.am4geodata_japanLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/japanLow.js
// module id = null
// module chunks = 